import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'ordersPendingForExchange';
export const ordersPendingForExchangeActions = makeActions(
  MODEL_NAME,
  'id',
  'orders',
);

export const getAllOrdersPendingForExchange =
  ordersPendingForExchangeActions.getAll;
export const editOrdersPendingForExchange =
  ordersPendingForExchangeActions.edit;
export const createOrdersPendingForExchange =
  ordersPendingForExchangeActions.create;
export const getByIdOrdersPendingForExchange =
  ordersPendingForExchangeActions.getDataById;
